import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignMediumParams from './CampaignMediumParams';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedCampaignMediumParams = connect(
  mapStateToProps, null,
)(CampaignMediumParams);

export default withTranslation(['administration'])(ConnectedCampaignMediumParams as any);
